import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import queryString from 'query-string';
import styled from 'styled-components';
import { useToasts } from 'react-toast-notifications';
import { useMutation } from '@apollo/client';
import { Formik, Field } from 'formik';
import Button from '../../elements/Button';
import FormikCheckbox from '../../elements/FormikCheckbox';
import InputFeedback from '../../elements/InputFeedback';
import Input from '../../styledComponents/Input';
import LinkButton from '../../styledComponents/LinkButton';
import { registrationDisabledText } from '../../constants';
import {
  confirmInviteV2Mut,
  initiatePasswordResetV2Mut,
  resendActivationLinkMut,
  resetPasswordV2Mut,
  signInV2Mut,
} from '../../queries/user';
import { setFormikErrorMessages } from '../../utils/errorMessages';
import { registerAtAnotherMandantMut, registerAtMandantV2Mut, registerMandantV2Mut } from '../../queries/mandant';

const StyledForm = styled.form`
    /* max-width: 600px; */
    width: 100%;
    /* display: flex; */
    /* flex-direction: column; */
    /* align-items: center; */

    /* Give every direct child some margin-bottom */

    & > * {
        margin-bottom: 10px;
    }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: end;
  gap: 10px;
`

const RegisterMandantHeader = styled.div`
    margin-top: 20px;
`;

const RegisterMandantHeadline = styled.h3`
    text-align: center;
`;

const StyledRegisterMandantHint = styled.p`
    text-align: left;
    font-size: 0.8em;
    font-style: italic;
`;

const Row = styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
`;

const StretchedRowElement = styled.div`
    min-width: 250px;
`;

const AuthenticationForm = ({
                              history,
                              location,
                              mandantSettings,
                              agbLink,
                              mandantName,
                              user,
                              purpose,
                            }) => {
  const { pathname } = location;
  const {
    handleSubmit,
    resendActivationLinkVisible,
    handleResendActivationLink,
  } = useAuthenticationFormState({ history, location, purpose });

  if (pathname.toLowerCase() !== '/authentication/confirm-invite' && mandantSettings?.registrationEnabled === false) {
    return <div>{registrationDisabledText}</div>;
  }

  return (
    <Formik
      initialValues={{
        email: '',
        firstName: '',
        lastName: '',
        mobile: user?.mobile ? user?.mobile : '',
        street: user?.address?.street ? user?.address?.street : '',
        streetNr: user?.address?.streetNr ? user?.address?.streetNr : '',
        zipCode: user?.address?.zipCode ? user?.address?.zipCode : '',
        city: user?.address?.city ? user?.address?.city : '',
        country: user?.address?.country ? user?.address?.country : '',
        mandantName: '',
        password: '',
        passwordConfirmation: '',
        agbAccepted: false,
        rememberMe: true,
      }}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={handleSubmit}>
      {({
          errors,
          touched,
          values,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
        <StyledForm onSubmit={handleSubmit}>
          {purpose === 'registerMandant' ? (
            <StyledRegisterMandantHint>
              Mit diesem Registrierungsformular legst Du einen neuen
              Anbieter-Account bei kursifant an um Buchungen von Teilnehmern zu
              verwalten. Es startet dann ein kostenloser, 14-tägiger
              Testzeitraum. Möchtest Du stattdessen bei einem Anbieter, der
              kursifant nutzt, Teilnehmer werden, muss Dir der Anbieter einen
              passenden Registrierungslink zur Verfügung stellen.
            </StyledRegisterMandantHint>
          ) : null}

          {purpose === 'confirmInvite' ? (
            <RegisterMandantHeader>
              <RegisterMandantHeadline>Hallo {user.firstName}!</RegisterMandantHeadline>
              <StyledRegisterMandantHint>
                Vergebe ein Passwort sowie evtl. nötige sonstige Angaben, um Deinen Account jetzt zu aktivieren.
                Anschließend kannst Du Dich einloggen und mit dem Buchen loslegen.
              </StyledRegisterMandantHint>
            </RegisterMandantHeader>
          ) : null}

          {purpose === 'registerMandant' && (
            <div>
              <Input
                type="text"
                name="mandantName"
                placeholder="Organisation"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.mandantName}
              />
              {errors.mandantName && touched.mandantName && (
                <InputFeedback error={errors.mandantName} />
              )}
            </div>
          )}

          {(purpose === 'registerMandant' ||
            purpose === 'login' ||
            purpose === 'initiatePasswordReset' ||
            purpose === 'registerAtMandant') && (
            <div>
              <Input
                type="email"
                name="email"
                placeholder="E-Mail"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
              />
              {errors.email && touched.email && (
                <InputFeedback error={errors.email} />
              )}
              {resendActivationLinkVisible ? (
                <div>
                  Du hast keine E-Mail erhalten? Klicke{' '}
                  <LinkButton
                    onClick={() => {
                      handleResendActivationLink(values.email);
                    }}>
                    hier
                  </LinkButton>{' '}
                  um die Bestätigungsmail erneut zu versenden.
                </div>
              ) : null}
            </div>
          )}

          {(purpose === 'confirmInvite' ||
            purpose === 'registerMandant' ||
            purpose === 'login' ||
            purpose === 'registerAtMandant' ||
            purpose === 'resetPassword') && (
            <div>
              <Input
                type="password"
                name="password"
                placeholder="Passwort"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.password}
              />
              {errors.password && touched.password && (
                <InputFeedback error={errors.password} />
              )}
            </div>
          )}

          {(purpose === 'confirmInvite' ||
            purpose === 'registerMandant' ||
            purpose === 'registerAtMandant' ||
            purpose === 'resetPassword') ? (
            <div>
              <Input
                type="password"
                name="passwordConfirmation"
                placeholder="Passwort wiederholen"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.passwordConfirmation}
              />
              {errors.passwordConfirmation && touched.passwordConfirmation && (
                <InputFeedback error={errors.passwordConfirmation} />
              )}
            </div>
          ) : null}

          {(purpose === 'registerMandant' ||
            purpose === 'registerAtMandant') && (
            <div>
              <Input
                type="text"
                name="firstName"
                placeholder="Vorname"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.firstName}
              />
              {errors.firstName && touched.firstName && (
                <InputFeedback error={errors.firstName} />
              )}
            </div>
          )}

          {(purpose === 'registerMandant' ||
            purpose === 'registerAtMandant') && (
            <>
              <div>
                <Input
                  type="text"
                  name="lastName"
                  placeholder="Nachname"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.lastName}
                />
                {errors.lastName && touched.lastName && (
                  <InputFeedback error={errors.lastName} />
                )}
              </div>
            </>
          )}

          {(purpose === 'confirmInvite' ||
            purpose === 'registerAtAnother' ||
            purpose === 'registerAtMandant') && (
            <>
              {mandantSettings?.newUserEnterMobile === 'show' ||
              mandantSettings?.newUserEnterMobile === 'required' ? (
                <div>
                  <Input
                    type="text"
                    name="mobile"
                    placeholder="Mobilnummer"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.mobile}
                  />
                  {errors.mobile && touched.mobile && (
                    <InputFeedback error={errors.mobile} />
                  )}
                </div>
              ) : null}
              {mandantSettings?.newUserEnterAddress === 'required' ? (
                <div>
                  <Row>
                    <StretchedRowElement>
                      <Input
                        type="text"
                        name="street"
                        placeholder="Straße"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.street}
                      />
                    </StretchedRowElement>
                    <div>
                      <Input
                        type="text"
                        name="streetNr"
                        placeholder="Hausnr."
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.streetNr}
                      />
                    </div>
                  </Row>
                  <div>
                    {errors.street && touched.street && (
                      <InputFeedback error={errors.street} />
                    )}
                    {errors.streetNr && touched.streetNr && (
                      <InputFeedback error={errors.streetNr} />
                    )}
                  </div>
                  <Row>
                    <div>
                      <Input
                        type="text"
                        name="zipCode"
                        placeholder="PLZ"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.zipCode}
                      />
                    </div>
                    <StretchedRowElement>
                      <Input
                        type="text"
                        name="city"
                        placeholder="Ort"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.city}
                      />
                    </StretchedRowElement>
                  </Row>
                  <div>
                    {errors.zipCode && touched.zipCode && (
                      <InputFeedback error={errors.zipCode} />
                    )}
                    {errors.city && touched.city && (
                      <InputFeedback error={errors.city} />
                    )}
                  </div>
                  <div>
                    <Input
                      type="text"
                      name="country"
                      placeholder="Land"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.country}
                    />
                    {errors.country && touched.country && (
                      <InputFeedback error={errors.country} />
                    )}
                  </div>
                </div>
              ) : null}
            </>
          )}

          {purpose === 'login' && (
            <Field name="rememberMe">
              {props => (
                <FormikCheckbox size={0.8} {...props}>
                  Für bis zu 30 Tage eingeloggt bleiben
                </FormikCheckbox>
              )}
            </Field>
          )}

          {(purpose === 'confirmInvite' ||
            purpose === 'registerMandant' ||
            purpose === 'registerAtMandant') && (
            <Field name="agbAccepted">
              {props => (
                <>
                  <FormikCheckbox size={0.6} {...props}>
                    Durch meine Registrierung erkläre ich mich mit den{' '}
                    <a
                      href="https://kursifant.com/agb/"
                      rel="noopener noreferrer"
                      target="_blank">
                      AGB
                    </a>{' '}
                    von kursifant
                    {agbLink ? (
                      <span>
                        {' '}
                        sowie den{' '}
                        <a
                          href={agbLink.url}
                          rel="noopener noreferrer"
                          target="_blank">
                          AGB
                        </a>{' '}
                        von {`${mandantName}`}
                      </span>
                    ) : null}{' '}
                    einverstanden (erforderlich)
                  </FormikCheckbox>
                </>
              )}
            </Field>
          )}

          <ButtonRow>
            {purpose === 'registerAtAnother' ?
              <>
                <Button type="button" onClick={() => {
                  history.push('/');
                }}>
                  Abbrechen
                </Button>
              </> : null}

            <Button fullWidth={!(purpose === 'registerAtAnother')}
                    type="submit"
                    disabled={isSubmitting}
            >
              {purpose === 'login' ? 'Einloggen' : null}
              {purpose === 'resetPassword'
                ? 'Neues Passwort setzen'
                : null}
              {purpose === 'initiatePasswordReset'
                ? 'Passwort zurücksetzen'
                : null}
              {purpose === 'confirmInvite'
                ? 'Account aktivieren'
                : null}
              {(purpose === 'registerAtMandant' || purpose === 'registerAtAnother')
                ? 'Registrieren'
                : null}
              {purpose === 'registerMandant'
                ? 'Neuen Anbieter-Account anlegen'
                : null}
            </Button>
          </ButtonRow>
        </StyledForm>
      )}
    </Formik>
  );
};

function useAuthenticationFormState({ history, location, purpose }) {
  const { addToast } = useToasts();
  const [resendActivationLinkVisible, setResendActivationLinkVisible] =
    useState(false);
  const { mandantRegisterId, resetToken } = useParams();
  const [signIn] = useMutation(signInV2Mut);
  const [resendActivationLink] = useMutation(resendActivationLinkMut);
  const [registerMandant] = useMutation(registerMandantV2Mut);
  const [registerAtMandant] = useMutation(registerAtMandantV2Mut);
  const [registerAtAnotherMandant] = useMutation(registerAtAnotherMandantMut);
  const [initiatePasswordReset] = useMutation(initiatePasswordResetV2Mut);
  const [resetPassword] = useMutation(resetPasswordV2Mut);
  const [confirmInvite] = useMutation(confirmInviteV2Mut);

  async function handleSubmit(values, actions) {
    setResendActivationLinkVisible(false);

    try {
      if (purpose === 'registerMandant') {
        await registerMandant({
          variables: {
            mandantName: values.mandantName,
            email: values.email,
            firstName: values.firstName,
            lastName: values.lastName,
            password: values.password,
            passwordConfirmation: values.passwordConfirmation,
            agbAccepted: values.agbAccepted,
          },
        });
        const redirectTo = `/authentication/confirm?type=registerOrganisation&email=${values.email}`;
        history.push(redirectTo);
      } else if (purpose === 'registerAtMandant') {
        await registerAtMandant({
          variables: {
            registerId: mandantRegisterId,
            email: values.email,
            firstName: values.firstName,
            lastName: values.lastName,
            mobile: values.mobile,
            street: values.street,
            streetNr: values.streetNr,
            zipCode: values.zipCode,
            city: values.city,
            country: values.country,
            password: values.password,
            passwordConfirmation: values.passwordConfirmation,
            agbAccepted: values.agbAccepted,
          },
        });
        const redirectTo = `/authentication/confirm?type=registerAtOrganisation&email=${values.email}`;
        history.push(redirectTo);
      } else if (purpose === 'registerAtAnother') {
        await registerAtAnotherMandant({
          variables: {
            registerId: mandantRegisterId,
            mobile: values.mobile,
            street: values.street,
            streetNr: values.streetNr,
            zipCode: values.zipCode,
            city: values.city,
            country: values.country,
          },
        });
        const toastText = 'Registrierung erfolgreich.';
        addToast(toastText, {
          appearance: 'success',
          autoDismiss: true,
        });
        history.push('/');
      } else if (purpose === 'initiatePasswordReset') {
        await initiatePasswordReset({
          variables: {
            email: values.email,
          },
        });
        const redirectTo = `/authentication/confirm?type=initiatePasswordReset&email=${values.email}`;
        history.push(redirectTo);
      } else if (purpose === 'resetPassword') {
        await resetPassword({
          variables: {
            resetToken,
            password: values.password,
            passwordConfirmation: values.passwordConfirmation,
          },
        });
        const redirectTo = `/authentication/confirm?type=resetTokenSuccess`;
        history.push(redirectTo);
      } else if (purpose === 'confirmInvite') {
        const parsedQuery = queryString.parse(location.search);
        const { activationToken } = parsedQuery;
        await confirmInvite({
          variables: {
            agbAccepted: values.agbAccepted,
            activationToken,
            password: values.password,
            passwordConfirmation: values.passwordConfirmation,
            mobile: values.mobile,
            street: values.street,
            streetNr: values.streetNr,
            zipCode: values.zipCode,
            city: values.city,
            country: values.country,
          },
        });
        const redirectTo = `/authentication/confirm?type=accountActivationSuccess`;
        history.push(redirectTo);
      } else {
        const result = await signIn({
          variables: {
            email: values.email,
            password: values.password,
          },
        });
        localStorage.setItem('auth_token', result.data.signInV2.token);
        // TODO redirect to where came from
        // const parsed = queryString.parse(props.location.search);
        // console.log(parsed);
        actions.setSubmitting(false);

        const parsedQuery = queryString.parse(location.search);
        // console.log(parsedQuery);

        let redirectTo = '/';
        if (parsedQuery.registerId) {
          redirectTo = `/register/at/${parsedQuery.registerId}`;
        }
        history.push(redirectTo);
      }
    } catch (error) {
      // console.log(error);
      // console.log(JSON.stringify(error, 0, 2));
      const errorResults = setFormikErrorMessages(actions, error);
      // console.log(errorResults);
      actions.setSubmitting(false);
      if (errorResults.includes('email-not-confirmed')) {
        setResendActivationLinkVisible(true);
      }
      if (errorResults.includes('activation-token-not-found')) {
        const redirectTo = `/authentication/confirm?type=activationTokenNotFound`;
        history.push(redirectTo);
      }
      if (errorResults.includes('already-registered')) {
        const toastText = 'Dein Account ist bereits bei dieser Organisation registriert.';
        addToast(toastText, {
          appearance: 'success',
          autoDismiss: true,
        });
        history.push('/');
      }
    }
  }

  async function handleResendActivationLink(email) {
    try {
      await resendActivationLink({ variables: { email } });
      const redirectTo = `/authentication/confirm?type=resendActivationLink&email=${email}`;
      history.push(redirectTo);
    } catch (error) {
      // console.log(JSON.stringify(error, 0, 2));
      if (error?.graphQLErrors?.length > 0) {
        if (error?.graphQLErrors[0].message === 'activation-token-already-sent-recently') {
          const toastText = 'Eine Aktivierungsmail wurde erst vor Kurzem verschickt. Bitte versuche es später nochmal.';
          addToast(toastText, {
            appearance: 'warning',
            autoDismiss: true,
          });
        } else if (error?.graphQLErrors[0].message === 'activation-token-not-found') {
          const redirectTo = `/authentication/confirm?type=activationTokenNotFound`;
          history.push(redirectTo);
        }
      }
    }
  }

  return {
    handleSubmit,
    resendActivationLinkVisible,
    handleResendActivationLink,
  };
}

// function setErrorMessages(actions, error, setResendActivationLinkVisible) {
//   // console.log(JSON.stringify(error, 0, 2));
//
//   if (error) {
//     if (
//       error.graphQLErrors &&
//       error.graphQLErrors.length > 0 &&
//       error.graphQLErrors[0].extensions &&
//       error.graphQLErrors[0].extensions.validationErrors
//     ) {
//       // console.log(error.graphQLErrors[0].extensions.validationErrors);
//       const { validationErrors } = error.graphQLErrors[0].extensions;
//       Object.entries(validationErrors).forEach(([field, errors]) => {
//         // console.log({
//         //   field,
//         //   errors,
//         // });
//         if (field === 'email' && errors[0].includes('noch nicht bestätigt')) {
//           setResendActivationLinkVisible(true);
//         }
//         actions.setFieldError(field, errors[0]);
//       });
//     }
//
//     if (
//       error &&
//       error.graphQLErrors &&
//       error.graphQLErrors.length > 0 &&
//       error.graphQLErrors[0].message === 'validation-error'
//     ) {
//       const errors = error.graphQLErrors[0].extensions.error.inner;
//       errors.forEach(error => {
//         // actions.setFieldError(error.path, error.type);
//         actions.setFieldError(error.path, generateErrorMessage(error));
//       });
//       // console.log(errors);
//     }
//
//     if (error.graphQLErrors[0].message === 'password-confirmation-mismatch') {
//       actions.setFieldError(
//         'passwordConfirmation',
//         'Passwort stimmt nicht überein'
//       );
//     }
//
//     if (error.graphQLErrors[0].message === 'activation-token-not-found') {
//       return 'activation-token-not-found';
//     }
//   }
// }

// function generateErrorMessage(error) {
//   // console.log(error);
//
//   const fieldName = getFieldLiteral(error.path);
//   // console.log(fieldName);
//
//   if (error.type === 'required') {
//     return `${fieldName} ist erforderlich`;
//   } else if (error.type === 'min') {
//     return `${fieldName} muss mindestens ${error.params.min} Zeichen lang sein`;
//   } else if (error.type === 'max') {
//     return `${fieldName} darf maximal ${error.params.max} Zeichen lang sein`;
//   } else {
//     return 'Unbekannter Fehler';
//   }
// }

// function getFieldLiteral(fieldName) {
//   const m = new Map();
//   m.set('password', 'Passwort');
//   m.set('passwordConfirmation', 'Passwort Wiederholung');
//   return m.get(fieldName);
// }

export default AuthenticationForm;
